<template>
  <div
    v-if="showSharePresentationBar && !isHideBar"
    class="share-presentation-bar horizontal layout center"
    :class="{'has-color': !isTextColourLight}"
  >
    <div>
      <div class="not-logged horizontal layout center" v-if="!$store.state.currentUser.id">
        <div class="flex">
          {{ $i18nPresenter.t('To copy this presentation, create your free AhaSlides account') }}
          <ShareSlideNote />
        </div>
        <div>
          <button class="btn btn-primary" @click="callAction('login')">
            {{ $i18nPresenter.t('Log in') }}
          </button>
          <button class="btn btn-light" @click="callAction('signup')">
            {{ $i18nPresenter.t('Sign up') }}
          </button>
        </div>
      </div>
      <div class="logged horizontal layout center" v-if="$store.state.currentUser.id">
        <div
          class="flex shared__presentation-title"
        >
          {{ $store.state.presentation.name }}
          <ShareSlideNote />
        </div>
        <div class="shared__copy-presentation">
          <button class="btn btn-primary" @click="copyPresentationShare()">
            <span v-if="copyStatus == 1">
              <i class="fas fa-copy fa-fw" />{{ $i18nPresenter.t('Copy') }}
            </span>
            <span v-if="copyStatus == 2">
              <span class="mr-1 loading-spinner mb--2px" />{{ $i18nPresenter.t('Copying...') }}
            </span>
            <span v-if="copyStatus == 3">
              <i class="fas fa-check-circle fa-fw" />{{ $i18nPresenter.t('Completed') }}
            </span>
            <span v-if="copyStatus == 4">{{ $i18nPresenter.t('Go to your presentations') }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="flex" v-if="!isEURegion">
    </div>
    <Comments
      :uniqueAccessCode="presentation.uniqueAccessCode"
      :presentationId="presentation.id"
      v-if="!presentation.disableConversationPresenterShare && presentation.id && !isEURegion"
      class="comment-box"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import util from '@/util'
import config from '@/config'
import mixpanelUtils from '@/utils/mixpanel.utils'
import ShareSlideNote from '@/components-v2/presentation-editor/collaboration/ShareSlideNote.vue'
import Comments from '@/components-v2/presentation-editor/comments/Comments.vue'
import constants from '@/constant'

export default {
  name: 'SharePresentationBar',
  components: {
    ShareSlideNote,
    Comments,
  },
  data() {
    return {
      copyStatus: 1,
      isHideBar: util.getParamValue('is_hide_presentation_bar', window.location.href),
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      sharePresentation: (state) => state.sharePresentation,
      presentation: (state) => state.presentation,
      isPresenterWhiteLabel: (state) => state.isPresenterWhiteLabel,
    }),
    ...mapGetters(['isTextColourLight']),
    showSharePresentationBar() {
      return this.sharePresentation && !this.isPresenterWhiteLabel && !this.isHideTextShare
    },
    isHideTextShare() {
      return !!util.getParamValue('hideText', window.location.href)
    },
    isEURegion() {
      return config.region === constants.euRegion
    },
  },
  methods: {
    callAction(type) {
      const inIframe = window.location !== window.parent.location

      let url
      if (type === 'login') {
        url = this.$router.resolve({
          name: 'Login',
          query: { redirect: window.location.href },
        })
        util.mixpanelTracking(
          'Presentation Share',
          `${inIframe ? 'iFrame > Log In' : 'Window > Log In'}`,
        )
      } else if (type === 'signup') {
        url = this.$router.resolve({
          name: 'Register',
          query: { redirect: window.location.href },
        })
        util.mixpanelTracking(
          'Presentation Share',
          `${inIframe ? 'iFrame > Sign Up' : 'Window > Sign Up'}`,
        )
      }

      if (url) {
        window.open(url.href, inIframe ? '_blank' : '_self')
      }
    },

    copyPresentationShare() {
      const inIframe = window.location !== window.parent.location
      if (this.copyStatus === 4) {
        util.mixpanelTracking(
          'Presentation Share',
          `${inIframe ? 'iFrame > Go to presentations' : 'Window > Go to presentations'}`,
        )
        window.open(`/presentation/${this.presentationCopyId}`, inIframe ? '_blank' : '_self')
        return
      }
      if (this.copyStatus > 1) {
        return
      }
      this.copyStatus = 2
      this.$http
        .post(config.api.copyPresentation, {
          id: this.$store.state.presentation.shareCode,
          name: this.$store.state.presentation.name,
          fromSharePage: true,
        })
        .then((res) => {
          this.presentationCopyId = res.body.id
          setTimeout(() => {
            this.copyStatus = 3
            setTimeout(() => {
              this.copyStatus = 4
            }, 1000)
          }, 2000)
          util.mixpanelTracking(
            'Presentation Share',
            'Create new presentation',
            `from Presentation Share > ${inIframe ? 'iFrame' : 'Window'}`,
            this.$store.state.presentation.id,
            {
              ...mixpanelUtils.getPresentationContext(this.$store.state.presentation),
            },
          )
        }).catch((err) => {
          if (err.status === 400) {
            window.location.href = config.accountRemovalURL
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.share-presentation-bar {
  width: 100%;
  min-height: 100px;
  background-color: #fff;
  color: #000;
  font-size: 15px;
  padding: 8px 16px;
  font-weight: bold;

  .logged,
  .not-logged {
    width: 100%;
  }

  .btn {
    margin-left: 8px;
    font-weight: bold;
  }

  &.has-color {
    background-color: #000;
    color: #fff;
  }

  @media (max-width: 400px) {
    font-size: 13px;
    padding: 8px;

    .btn {
      font-size: 13px;
    }
  }
}

@media (max-width: 1024px) {
  .share-presentation-bar {
    display: block !important;

    .comment-box {
      padding: 16px 0;
    }
  }
}
</style>
